import { YouTube } from '@sparemin/blockhead';
import { AdCampaignResultWithContentDetail } from 'api';
import * as S from './styles';

export interface PreviousCampaignThumbnailProps {
  campaign: AdCampaignResultWithContentDetail;
}

const PreviousCampaignThumbnail: React.FC<PreviousCampaignThumbnailProps> = ({
  campaign,
}) => {
  const { contentType, contentDetail } = campaign;

  if (contentType === 'youtubeVideo') {
    return contentDetail.thumbnailUrl ? (
      <S.YoutubeThumbnail
        src={contentDetail.thumbnailUrl}
        alt="video thumbnail"
      />
    ) : (
      <S.YoutubeThumbnailFallback>
        <YouTube width="29px" height="20px" />
      </S.YoutubeThumbnailFallback>
    );
  }

  return (
    <S.Thumbnail
      src={
        contentDetail.episodeThumbnailUrl || contentDetail.podcastThumbnailUrl
      }
      alt="podcast artwork"
    />
  );
};

export default PreviousCampaignThumbnail;
